<div *transloco="let t" class="col grid-item">
  <div [class.zoom-wrapper]="zoomEffect">
    <div class="event-card position-relative" [class.zoom-target]="zoomEffect">
      <div class="image-wrapper" [class.finished]="isFinishedEvent">
        <div class="finished-event-ribbon d-flex justify-content-between align-items-center">
          <div class="finished-event-ribbon__status text-uppercase">
            @if(isFinishedEvent){
            <span>{{ t('event.item.status.2') }}</span>
            }
          </div>
          <div class="race-date-wrapper">
            <span class="race-date-wrapper__month text-uppercase pe-2"
              [innerHTML]="eventItem && eventItem.start ? formatDate(eventItem!.start!) : ''"></span>

            <span [innerHTML]="eventItem && eventItem.start ? (eventItem!.start | date:'d') : ''"></span>
            @if(checkSameDate(eventItem)){
            <div>
              -
              <span [innerHTML]="eventItem && eventItem.end ? (eventItem!.end | date:'d') : ''"></span>
            </div>
            }
            <span>.</span>
            <span [innerHTML]="eventItem && eventItem.start ? (eventItem!.start | date:'yyyy') : ''"></span>
          </div>
        </div>
        <div class="position-relative">
          @if(eventItem?.imageMedium !== null){
            <img src="{{eventItem?.imageMedium}}" alt="" class="bck-img" appImageFallback>
          } @else {
            <img src="{{environment.assetsImagesPath + '/assets/img/mountain.png'}}" alt="" class="bck-img" appImageFallback>
          }
          <div class="img-overlay"></div>
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center">
        <div class="title-wrapper">
          <h5 class="title-wrapper__title mb-0 trim-text-second-line">
            <app-language-output [hrLabel]="eventItem?.name" [enLabel]="eventItem?.nameEng"
              [itLabel]="eventItem?.nameIta" [siLabel]="eventItem?.nameSlo"
              [defaultLanguage]="eventItem?.defaultLanguage" [languages]="languages" />
          </h5>
          <div class="title-wrapper__location">
            @if(eventItem?.city || eventItem?.country){
            <img src="assets/icons/location-icon.svg" alt="Running" class="card-body__icon" />
            }
            <div class="title-wrapper__location-text">
              <span>
                {{ eventItem?.city }}
              </span>
              @if(eventItem?.country){
              <span>{{ ',' }}</span>
              }
              @if(eventCountry?.shortCode){
              <span>
                <span class="ps-1">{{ eventCountry?.shortCode }}</span>
              </span>
              }
            </div>
          </div>
        </div>
      </div>
      <div>
        <ul class="square-list square-list--inline">
          @if (eventItem?.sportOne || eventItem?.sportTwo) {
          <li class="text-uppercase fw-semibold">
            @if (eventItem?.sportOne) {
            <small>{{ t("app.common.sports." + eventItem?.sportOne) }}</small>
            }
            @if (eventItem?.sportTwo) {
            <small>{{ t("app.common.sports." + eventItem?.sportTwo) }}</small>
            }
          </li>
          }
          @if (eventItem?.leagueName || eventItem?.leagueNameEn || eventItem?.leagueNameSl || eventItem?.leagueNameIt) {
          <li>
            <app-language-output [hrLabel]="eventItem?.leagueName" [enLabel]="eventItem?.leagueNameEn"
              [itLabel]="eventItem?.leagueNameIt" [siLabel]="eventItem?.leagueNameSl"
              [defaultLanguage]="eventItem?.defaultLanguage" [languages]="languages" />
            @if (eventItem?.round !== null && eventItem?.round !== undefined) {
            {{ "-" + eventItem?.round }}
            }
          </li>
          }
        </ul>
      </div>
      <div class="event-card__distance d-flex align-items-stretch">
        <div class="race-length-wrapper d-flex align-items-center flex-grow-1">
          <img src="assets/icons/location-icon-alt.svg" alt="Running"
            class="card-body__icon card-body__icon--distance me-2" />
          @for (length of lengths;track length;let idx=$index) {
          <span>
            {{ length | raceLengthFormat:translocoService.getActiveLang() }}
          </span>
          @if((idx < lengths.length-1)){ <span class="race-length-wrapper__separator">|</span>
            }
            }
        </div>
        <div class="heart-icon-wrapper d-flex align-items-center justify-content-center">
          @if((eventItem?.favorite || isItemFavorite)&& !isPreviewComponent) {
          <img src="assets/icons/red-heart.svg" alt="Heart" (click)="addToFavoritesButtonClicked($event)" />
          } @else {
          <img src="assets/icons/red-outlined-heart.svg" alt="Heart" (click)="addToFavoritesButtonClicked($event)" />
          }
        </div>
      </div>
      @if(!isLanding && !isFinishedEvent){
      <div class="event-card__race-it-wrapper d-flex align-items-center justify-content-center">
        <app-rounded-button [label]="t('event.race.it')" />
      </div>
      }
      @if(!isLanding && isFinishedEvent){
      <div>
        <div class="participants-box d-flex align-items-start flex-column">
          <div class="d-flex align-items-center">
            <span class="participants-box__svg">
              <img src="assets/img/svg/finished-participants.svg"
                [alt]="t('events.finished.events.finished.participants')" class="img-fluid">
            </span>
            <span class="me-8"> {{ t("events.finished.events.finished.participants") }}:</span>
            <!--          TODO-->
            <app-badge [label]="eventItem?.finCompetitorCnt ?? 0" />
          </div>
          <div class="d-flex align-items-center">
            <span class="participants-box__svg">
              <img src="assets/img/svg/flag.svg" [alt]="t('events.finished.events.countries')" class="img-fluid">
            </span>
            <span class="me-8"> {{ t("events.finished.events.countries") }}:</span>
            <app-badge [label]="eventItem?.competitorCountriesCnt ?? 0" />
          </div>
        </div>
        <div class="event-card__race-it-wrapper d-flex align-items-center justify-content-center">
          <app-rounded-button [label]="t('events.details.results')" />
        </div>
      </div>
      }
    </div>
  </div>
</div>
